import {
  getMyCalendar,
} from 'frontend/communications/myCalendar'

const stateObj = {
  events: [],
}

const getters = {
  getMyCalendar (state) {
    return state.events
  },
}

const mutations = {
  setMyCalendar (state, value) {
    state.events = value
  },
}

const actions = {
  async fetchMyCalendar ({ commit }, payload) {
    const response = await getMyCalendar(payload)
    commit('setMyCalendar', response)
    return response
  },
}

export default {
  actions,
  getters,
  mutations,
  state: stateObj,
}

